import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { QuestionType } from '../../../../../form';
import { BaseQuestionSwitchStrategy } from './base.strategy';
/**
 * Strategy: Matching → Other Types
 * Rule 7: Matching → Any resets similar to Fill in Blank
 */

export var MatchingSwitchStrategy = /*#__PURE__*/function (_BaseQuestionSwitchSt) {
  _inherits(MatchingSwitchStrategy, _BaseQuestionSwitchSt);

  var _super = _createSuper(MatchingSwitchStrategy);

  function MatchingSwitchStrategy() {
    _classCallCheck(this, MatchingSwitchStrategy);

    return _super.call(this, QuestionType.Matching);
  }

  _createClass(MatchingSwitchStrategy, [{
    key: "canHandle",
    value: function canHandle(toType) {
      return this.fromType === QuestionType.Matching;
    }
  }, {
    key: "execute",
    value: function execute(toType) {
      switch (toType) {
        case QuestionType.SingleChoice:
        case QuestionType.MultipleChoice:
          // Rule 7: Matching → Choice types resets description & answers
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: false,
            // Reset description too!
            shouldResetToDefault: true,
            shouldClearAnswers: true,
            strategyName: "Matching \u2192 ".concat(toType, ": Reset all (description + answers)")
          };

        case QuestionType.Essay:
          // Rule 5: Any → Essay clears all answers
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: true,
            shouldResetToDefault: false,
            shouldClearAnswers: true,
            strategyName: 'Matching → Essay: Clear answers'
          };

        case QuestionType.FillInBlank:
          // Rule 7: Matching → Fill in Blank resets to different complex type
          return {
            shouldPreserveAnswers: false,
            shouldPreserveDescription: true,
            shouldResetToDefault: true,
            shouldClearAnswers: true,
            strategyName: 'Matching → FillInBlank: Reset to complex type'
          };

        default:
          return this.getDefaultResult(toType);
      }
    }
  }, {
    key: "getDefaultResult",
    value: function getDefaultResult(toType) {
      return {
        shouldPreserveAnswers: false,
        shouldPreserveDescription: false,
        shouldResetToDefault: true,
        shouldClearAnswers: true,
        strategyName: "Matching \u2192 ".concat(toType, ": Default behavior")
      };
    }
  }]);

  return MatchingSwitchStrategy;
}(BaseQuestionSwitchStrategy);